import React from "react";
import { useNavigate } from "react-router-dom";
import { HelpCircle, Phone, FileText, ChevronRight } from "lucide-react";

export const InfoMenu: React.FC = () => {
  const navigate = useNavigate();

  const items = [
    { path: "/info/how-to-find-link", icon: HelpCircle, title: "Как найти ссылку?", subtitle: null },
    { path: "/info/contacts", icon: Phone, title: "Контакты", subtitle: "Наш бот, поддержка" },
    { path: "/info/legal", icon: FileText, title: "Справочная информация", subtitle: "Политика конфиденциальности, пользовательское соглашение" },
  ];

  return (
    <div style={styles.container}>
      <h1 style={styles.title}>Информация</h1>
      <div style={styles.list}>
        {items.map((item) => {
          const Icon = item.icon;
          return (
            <button key={item.path} style={styles.card} onClick={() => navigate(item.path)}>
              <div style={styles.cardIcon}>
                <Icon size={20} />
              </div>
              <div style={styles.cardText}>
                <div style={styles.cardTitle}>{item.title}</div>
                {item.subtitle && <div style={styles.cardSubtitle}>{item.subtitle}</div>}
              </div>
              <ChevronRight size={18} style={{ color: "var(--tg-theme-hint-color, #999)" }} />
            </button>
          );
        })}
      </div>
    </div>
  );
};

const styles: Record<string, React.CSSProperties> = {
  container: { padding: "16px", maxWidth: "480px", margin: "0 auto" },
  title: { fontSize: "22px", fontWeight: 700, margin: "0 0 16px 0", color: "var(--tg-theme-text-color, #000)" },
  list: { display: "flex", flexDirection: "column", gap: "10px" },
  card: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    padding: "14px",
    backgroundColor: "var(--tg-theme-secondary-bg-color, #fff)",
    borderRadius: "14px",
    border: "none",
    cursor: "pointer",
    textAlign: "left",
    width: "100%",
    boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
  },
  cardIcon: {
    width: "40px",
    height: "40px",
    borderRadius: "10px",
    backgroundColor: "var(--tg-theme-button-color, #2481cc)20",
    color: "var(--tg-theme-button-color, #2481cc)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  },
  cardText: { flex: 1 },
  cardTitle: { fontSize: "15px", fontWeight: 600, color: "var(--tg-theme-text-color, #000)" },
  cardSubtitle: { fontSize: "12px", color: "var(--tg-theme-hint-color, #666)", marginTop: "2px" },
};
